import { Component, OnInit, Input } from '@angular/core';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { StatusRoteiro } from '../shared/Util';

@Component({
    selector: 'roteiro-card',
    templateUrl: './roteiro-card.component.html',
    styleUrls: ['./roteiro-card.component.css'],
    standalone: true,
    imports: [NgClass, NgIf, NgStyle]
})
export class RoteiroCardComponent implements OnInit {

  @Input() dados;
  @Input() totais;

  get isCrossdocking(): boolean {
    return this.dados?.TipoRoteiroID === 2;
  }

  constructor() { }

  ngOnInit() {
    this.dados.placaVeiculo = this.formataPlacaVeiculo(
      this.dados.cod_veiculo || this.dados.veiculo
    );

    if (this.isCrossdocking) {
      this.dados.porcentagem = 0;
      this.dados.tooltip = '-';
      this.dados.icone = this.dados.IdRoteiroSituacao == StatusRoteiro.Finalizado? 'assets/img/icons/flag-crossdocking-white.svg' : 'assets/img/icons/flag-crossdocking.svg';

      this.dados.totalPaletes = (this.dados.roteirosCrossdocking ?? []).reduce(
        (total, roteiro) => total + (roteiro.paletes ?? 0),
        0
      );
      return;
    }

    const total = this.totais.find(t => t.NumeroRoteiro == this.dados.roteiro);
    this.totais = total;
    this.dados.porcentagem = this.porcentagem();
    this.dados.tooltip = this.tooltipTexto(total?.situacao);

    if (this.dados.porcentagem != 100) {
      this.dados.icone = !this.dados.RoteiroTransportadora
        ? 'assets/img/icons/icon_roteiro_card_distri.svg'
        : 'assets/img/icons/icon_roteiro_card_transp.svg';
    } else {
      this.dados.icone = !this.dados.RoteiroTransportadora
        ? 'assets/img/icons/icon_roteiro_card_distri_w.svg'
        : 'assets/img/icons/icon_roteiro_card_transp_w.svg';
    }
  }

  formataPlacaVeiculo(placa) {
    if (!placa) return '';
    placa = placa.trim();
    return placa.substring(0, 3) + '-' + placa.substring(3, 8);
  }

  porcentagem(){
    return Number(((this.dados.realizadas * 100) / (this.dados.QtdeEntregas == 0 ? 1 : this.dados.QtdeEntregas)).toFixed(0));
  }

  tooltipTexto(situacao){
    let text = 'Tooltip';

    if(situacao == null || situacao == undefined){
      return '-';
    }

    switch (situacao) {
      case 'Iniciou':
        text = 'Roteiro Ativo.';
        break;
      case 'Pausou':
        text = 'Roteiro Pausado.';
        break;
      case 'Roteiro Ativado':
        text = 'O Roteiro foi ativado.';
        break;
      case 'Saiu':
        text = 'Motorista saiu do aplicativo.';
        break;
      case '-':
        text = 'Roteiro Não Iniciado';
        break;
    }
    return text;
  }
}
